import React,{useState,useEffect,useCallback} from 'react'
import Title from '../../../components/panelcontrols/paneltitle'
import Input from '../../../components/panelcontrols/panelinput'
import Select from '../../../components/panelcontrols/panelselect'
import Button from '../../../components/panelcontrols/panelbuttonmain'
import DoctorFunctions from '../doctors/functions'
import './index.css'
import Functions from './functions'
import { ToastContainer, toast } from 'react-toastify';
import Table from './billingTable'

const Index = () => {
  const [list,setList] = useState([]);
  const [doctor,setDoctor] = useState({value:0,name:'Select doctor'});
  const [doctorlist,setDoctorList] = useState([]);
  const [month,setMonth] = useState({value:0,name:'Select month'});
  const [monthlist] = useState([
    {value:1,name:'January'},
    {value:2,name:'February'},
    {value:3,name:'March'},
    {value:4,name:'April'},
    {value:5,name:'May'},
    {value:6,name:'June'},
    {value:7,name:'July'},
    {value:8,name:'August'},
    {value:9,name:'September'},
    {value:10,name:'October'},
    {value:11,name:'November'},
    {value:12,name:'December'},
  ]);
  const [expiredate,setExpireDate] = useState('');
  // list: pagination + server-side search + filters
  const [page,setPage] = useState(1);
  const [paginationInfo,setPaginationInfo] = useState({ pages: 1, total: 0, years: [] });
  const [searchTerm,setSearchTerm] = useState('');
  const [debouncedSearch,setDebouncedSearch] = useState('');
  const [filterMonth,setFilterMonth] = useState({value:0,name:'All months'});
  const [filterYear,setFilterYear] = useState({value:0,name:'All years'});
  const [filterFrom,setFilterFrom] = useState('');
  const [filterTo,setFilterTo] = useState('');
  const limit = 20;
  // Starts true so the first paint is a shimmer rather than "No data available".
  // apiGetList guarantees applyList runs even on failure, so this always clears.
  const [loading,setLoading] = useState(true);
  const applyList = (data)=>{
    setList(data);
    setLoading(false);
  };
  useEffect(()=>{
    DoctorFunctions.Get((data)=>{
      const sendData = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        sendData.push({
          value : parseInt(element.id),
          name : element.firstname + " " + element.lastname + " / " + element.clinicname
        })
      }
      setDoctorList(sendData)
    })
  },[])

  useEffect(()=>{
    const t = setTimeout(()=>{
      setDebouncedSearch(searchTerm);
      setPage(1);
    },350);
    return ()=>clearTimeout(t);
  },[searchTerm]);

  const loadList = useCallback(()=>{
    Functions.Get(applyList, setPaginationInfo, page, limit, debouncedSearch, {
      month: filterMonth.value || '',
      year: filterYear.value || '',
      from: filterFrom,
      to: filterTo
    });
  },[page, debouncedSearch, filterMonth, filterYear, filterFrom, filterTo]);

  useEffect(()=>{ loadList(); },[loadList])

  // any filter change must go back to page 1, or you land on an out-of-range page
  const applyFilter = (setter) => (value) => { setter(value); setPage(1); };
  const hasFilters = !!(filterMonth.value || filterYear.value || filterFrom || filterTo || searchTerm);
  const clearFilters = ()=>{
    setFilterMonth({value:0,name:'All months'});
    setFilterYear({value:0,name:'All years'});
    setFilterFrom('');
    setFilterTo('');
    setSearchTerm('');
    setPage(1);
  };

  const reset = ()=>{
    setDoctor({value:0,name:'Select doctor'})
    setMonth({value:0,name:'Select month'})
    setExpireDate('');
  }
  return (
    <div className='labadmin_billing_container'>
      <Title Value={'Billing'}/> 
      <div className='admin_billing_formbox'>
        <Select Lable={'Doctor'} Value={doctor} setValue={setDoctor} Options={doctorlist}/>
        <Select Lable={'Month'} Value={month} setValue={setMonth} Options={monthlist}/>
        <Input Lable={'Due Date'} Type={'date'} Value={expiredate} setValue={setExpireDate}/>
        <Button Value={'Save'} Action={()=>{
          const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
          if(doctor.value === 0 || month.value === 0 || expiredate === ''){
            toast.update(toastid, { render: "Fields Empty", type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            return;
          }
          Functions.Post({
            doctor: doctor.value, 
            month : month.value,
            duedate: expiredate
          },loadList,toast,toastid,(newBillId)=>{
            reset();
            window.open(`/labadminreport/billingdetailed?doctor=${doctor.value}&month=${month.value}&duedate=${expiredate}&billno=${newBillId}`);
          })
        }} />
      </div>
      <div className='billing_filters'>
        <div className='billing_filters_field'>
          <Select Lable={'Month'} Value={filterMonth} setValue={applyFilter(setFilterMonth)}
                  Options={[{value:0,name:'All months'},...monthlist]}/>
        </div>
        <div className='billing_filters_field'>
          <Select Lable={'Year'} Value={filterYear} setValue={applyFilter(setFilterYear)}
                  Options={[{value:0,name:'All years'},...(paginationInfo.years||[]).map(y=>({value:y,name:String(y)}))]}/>
        </div>
        <div className='billing_filters_field'>
          <Input Lable={'Due from'} Type={'date'} Value={filterFrom} setValue={applyFilter(setFilterFrom)}/>
        </div>
        <div className='billing_filters_field'>
          <Input Lable={'Due to'} Type={'date'} Value={filterTo} setValue={applyFilter(setFilterTo)}/>
        </div>
        <button className='billing_filters_clear' onClick={clearFilters} disabled={!hasFilters}>
          Clear
        </button>
      </div>
      <Table loading={loading} List={list} setList={setList} search={searchTerm} onSearch={setSearchTerm} toast={toast}/>
      <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'12px',padding:'16px'}}>
        <button
          onClick={()=>setPage(p=>p-1)}
          disabled={page<=1}
          style={{padding:'6px 16px',cursor:page<=1?'not-allowed':'pointer',opacity:page<=1?0.5:1,borderRadius:'4px',border:'1px solid #ccc'}}>
          Previous
        </button>
        <span style={{fontSize:'14px'}}>Page {page} of {paginationInfo.pages || 1} &nbsp;|&nbsp; Total: {paginationInfo.total || 0}</span>
        <button
          onClick={()=>setPage(p=>p+1)}
          disabled={page>=(paginationInfo.pages||1)}
          style={{padding:'6px 16px',cursor:page>=(paginationInfo.pages||1)?'not-allowed':'pointer',opacity:page>=(paginationInfo.pages||1)?0.5:1,borderRadius:'4px',border:'1px solid #ccc'}}>
          Next
        </button>
      </div>
      <ToastContainer/>
    </div>
  )
}

export default Index
